import React, { useState, useEffect } from 'react';
import { getInitials, stringToColor } from '../utils/helpers';
import api from '../utils/api';

const Avatar = ({ name, userId, size = 'md', className = '' }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(false);

  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl'
  };

  useEffect(() => {
    const loadProfilePicture = async () => {
      if (!userId) return;

      try {
        const response = await api.get(`/auth/profile-picture/${userId}`, {
          responseType: 'blob'
        });
        const url = URL.createObjectURL(response.data);
        setImageUrl(url);
      } catch (err) {
        // No profile picture, use initials
        setError(true);
      }
    };

    loadProfilePicture();

    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [userId]);

  const initials = getInitials(name);
  const bgColor = stringToColor(name);

  if (imageUrl && !error) {
    return (
      <img
        src={imageUrl}
        alt={name}
        className={`${sizeClasses[size]} rounded-full object-cover ${className}`}
        onError={() => setError(true)}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-semibold text-white ${className}`}
      style={{ backgroundColor: bgColor }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
